import useTranslate from '@core/hooks/useTranslate';
import PageTop from '@root/modules/Sellers/Dashboard/components/PageTop/index';
import BreadcrumbList from '@root/modules/Sellers/Stock/components/Breadcrumb';
import { Card, Spin } from 'antd';
import { useState } from 'react';
import OrderStatus from '../components/OrderStatus';
import SellerList from '../components/SellerList';
import WrapCardTotal from '../components/WrapCardTotal';

interface Props {}
const Breadcrumb = [
  {
    tittle: 'Dashboard',
    url: '/admin/warehouse'
  }
];
const WarehousePage = (props: Props) => {
  const [t] = useTranslate();

  const [loading, setLoading] = useState(false);

  return (
    <Spin spinning={loading}>
      <BreadcrumbList listBreadcrumb={Breadcrumb} />
      <div className="admin-container ">
        <Card
          bordered={false}
          className="admin-card"
          style={{
            minHeight: '80vh',
            background: 'none'
          }}
        >
          <WrapCardTotal />
          <div
            style={{
              marginTop: '20px',
              display: 'flex',
              justifyContent: 'space-between'
            }}
          >
            <OrderStatus setLoading={setLoading} />
            <SellerList setLoading={setLoading} />
          </div>
        </Card>
      </div>
    </Spin>
  );
};

export default WarehousePage;
